import { isBarOrProfile, isSheetPartType } from "../helpers";
import { PartTypeType } from "../types";

type Props = {
  partType: PartTypeType | null;
  length: number | null;
  width: number | null;
  height: number | null;
  tubeThickness: number | null;
};

const ensurePositiveVolume = (volume: number) => Math.max(0, volume);

export const computeVolumeM3 = ({
  partType,
  length,
  width,
  height,
  tubeThickness,
}: Props): number => {
  const sanitizedLength = length || 0;
  const sanitizedWidth = width || 0;
  const sanitizedHeight = height || 0;
  const sanitizedTubeThickness = tubeThickness || 0;

  if (isSheetPartType(partType)) {
    return ensurePositiveVolume(
      (sanitizedLength / 1000) * (sanitizedWidth / 1000) * (sanitizedHeight / 1000),
    );
  }

  if (partType === "MACHINING") {
    return ensurePositiveVolume(
      (sanitizedLength / 1000) * (sanitizedWidth / 1000) * (sanitizedHeight / 1000),
    );
  }

  if (isBarOrProfile(partType)) {
    if (partType === "SQUARE_BAR") {
      return ensurePositiveVolume(
        (sanitizedWidth / 1000) * (sanitizedWidth / 1000) * (sanitizedLength / 1000),
      );
    }

    if (partType === "SQUARE_TUBE" || partType === "RECTANGULAR_TUBE") {
      const outerVolume =
        (sanitizedWidth / 1000) * (sanitizedHeight / 1000) * (sanitizedLength / 1000);
      const innerWidth = (sanitizedWidth - 2 * sanitizedTubeThickness) / 1000;
      const innerHeight = (sanitizedHeight - 2 * sanitizedTubeThickness) / 1000;
      const innerVolume = innerWidth * innerHeight * (sanitizedLength / 1000);

      return ensurePositiveVolume(outerVolume - innerVolume);
    }

    if (partType === "ROUND_BAR") {
      return ensurePositiveVolume(
        Math.PI * Math.pow(sanitizedHeight / 2 / 1000, 2) * (sanitizedLength / 1000),
      );
    }

    if (partType === "ROUND_TUBE") {
      const sanitizedInnerRadius = (sanitizedHeight - 2 * sanitizedTubeThickness) / 2 / 1000;
      return ensurePositiveVolume(
        Math.PI *
          (sanitizedLength / 1000) *
          (Math.pow(sanitizedHeight / 2 / 1000, 2) - Math.pow(sanitizedInnerRadius, 2)),
      );
    }

    if (partType === "PROFILE") {
      return ensurePositiveVolume(
        (sanitizedWidth / 1000) * (sanitizedHeight / 1000) * (sanitizedLength / 1000),
      );
    }
  }

  return 0;
};
